import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DCard from "../../components/card/DCard";
import DCardHeader from "../../components/card/DCardHeader";
import DCardBody from "../../components/card/DCardBody";
import Select from "react-select";
import InputMask from "react-input-mask";
import { Table } from "react-bootstrap";

import { arrhythmiaDiagnosisTypes } from "../../../enum/enums";

const ArrhythmiaDiagnosisCard = props => {
    const {
        children,
        className,
        //
        onRequestAdd,
        arrhythmiaDiagnosisListParm,
        ...attributes
    } = props;

    const [arrhythmiaDiagnosisList, setArrhythmiaDiagnosisList] = useState(arrhythmiaDiagnosisListParm);
    const [type, setType] = useState(null);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [idRowEditing, setIdRowEditing] = useState(undefined);

    useEffect(() => {
        setArrhythmiaDiagnosisList(arrhythmiaDiagnosisListParm);
    }, [arrhythmiaDiagnosisListParm]);

    function handleAddArrhythmiaDiagnosis() {
        if (!isEditing) {
            const newArrhythmiaDiagnosisItem = {
                id: (Math.floor(Math.random() * 65536)).toString(),
                type,
                month,
                year
            };

            const newArrhythmiaDiagnosisList = [...arrhythmiaDiagnosisList, newArrhythmiaDiagnosisItem];
            setArrhythmiaDiagnosisList(newArrhythmiaDiagnosisList);
            onRequestAdd(newArrhythmiaDiagnosisList);
        } else {
            const newArrhythmiaDiagnosisList = arrhythmiaDiagnosisList.map(arrhythmiaDiagnosisItem => {
                if (arrhythmiaDiagnosisItem.id === idRowEditing) {
                    return {
                        id: arrhythmiaDiagnosisItem.id,
                        type,
                        month,
                        year
                    }
                }

                return arrhythmiaDiagnosisItem;
            })
            setArrhythmiaDiagnosisList(newArrhythmiaDiagnosisList);
            onRequestAdd(newArrhythmiaDiagnosisList);
        }

        resetFields();
    }

    function handleEditArrhythmiaDiagnosis(id) {
        const editRowInfo = arrhythmiaDiagnosisList.find(x => x.id === id);
        if (editRowInfo) {
            setType(editRowInfo.type);
            setMonth(editRowInfo.month);
            setYear(editRowInfo.year);

            setIdRowEditing(id);
            setIsEditing(true);
        }
    }

    function handleDeleteArrhythmiaDiagnosis(id) {
        const newArrhythmiaDiagnosisList = arrhythmiaDiagnosisList.filter(x => x.id !== id);
        setArrhythmiaDiagnosisList(newArrhythmiaDiagnosisList);
        onRequestAdd(newArrhythmiaDiagnosisList);
    }

    function resetFields() {
        setType(null);
        setMonth("");
        setYear("");

        setIsEditing(false);
        setIdRowEditing(undefined);
    }

    return (
        <>
            <DCard borderColor="light">
                <DCardHeader color="light" textColor="dark">Diagnóstico de Arritmia</DCardHeader>
                <DCardBody>
                    <div className="basic-form">
                        <div className="row">
                            <div className="form-group mb-3 col-md-6">
                                <label><small>Diagnóstico de Arritmia</small></label>
                                <Select
                                    isClearable
                                    defaultValue={type}
                                    value={type}
                                    onChange={(e) => setType(e)}
                                    options={arrhythmiaDiagnosisTypes}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            height: 45,
                                            backgroundColor: state.isDisabled ? "#dde0e3" : ""
                                        }),
                                    }}
                                    placeholder="Selecione..."
                                />
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Mês</small></label>
                                <InputMask
                                    mask="99"
                                    maskChar=" "
                                    value={month}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 2) return false;
                                        setMonth(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <label><small>Ano</small></label>
                                <InputMask
                                    mask="9999"
                                    maskChar=" "
                                    value={year}
                                    onChange={(event) => {
                                        if (event.target.value.length !== 4) return false;
                                        setYear(event?.target.value);
                                    }}
                                    alwaysShowMask={true}
                                >
                                    {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                                </InputMask>
                            </div>
                            <div className="form-group mb-3 col-md-2">
                                <button className="btn btn-primary shadow mt-4 ms-1" onClick={handleAddArrhythmiaDiagnosis}>
                                    <i className="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group mb-3 col-md-12" hidden={arrhythmiaDiagnosisList.length === 0}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <strong>Diganóstico de Arritmia</strong>
                                            </th>
                                            <th>
                                                <strong>Mês</strong>
                                            </th>
                                            <th>
                                                <strong>Ano</strong>
                                            </th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            arrhythmiaDiagnosisList.map((arrhythmiaDiagnosisItem) => {
                                                return (
                                                    <tr key={arrhythmiaDiagnosisItem.id}>
                                                        <td>{arrhythmiaDiagnosisItem.type.label}</td>
                                                        <td>{arrhythmiaDiagnosisItem.month}</td>
                                                        <td>{arrhythmiaDiagnosisItem.year}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn btn-info shadow sharp ms-1"
                                                                    onClick={() => handleEditArrhythmiaDiagnosis(arrhythmiaDiagnosisItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-pencil-alt"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger shadow sharp ms-1"
                                                                    onClick={() => handleDeleteArrhythmiaDiagnosis(arrhythmiaDiagnosisItem.id)}
                                                                    disabled={isEditing}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </DCardBody>
            </DCard>
        </>
    )
}

ArrhythmiaDiagnosisCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

ArrhythmiaDiagnosisCard.defaultProps = {
    arrhythmiaDiagnosisListParm: []
};

export default ArrhythmiaDiagnosisCard;